import Swiper from "swiper";
import { EffectCoverflow, Keyboard } from "swiper/modules";

// Figma: de buurslide is 308 van 418 breed (cos 42°). De hoek groeit per slide, dus 3 slides verder staat hij op 126°: de loop houdt daarom extra slides achter de hand.
const coverflow = { rotate: 42, depth: 150, modifier: 1, slideShadows: false };
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

document.querySelectorAll(".swiper_steps-layout").forEach((layout) => {
	const slider = layout.querySelector(".steps-swiper");
	if (!slider) return;

	// De PHP herhaalt de stappen voor de loop; de dots horen bij de echte stappen (data-step).
	const names = [];
	slider.querySelectorAll(".swiper-slide").forEach((slide) => {
		names[slide.dataset.step] ??= slide.querySelector(".title")?.textContent.trim() ?? "";
	});

	const dots = layout.querySelector(".pk-pagination");
	const bullets = names.map((name, i) => {
		const bullet = document.createElement("button");
		bullet.type = "button";
		bullet.className = "swiper-pagination-bullet";
		bullet.setAttribute("aria-label", name);
		bullet.dataset.step = i;
		dots?.append(bullet);
		return bullet;
	});

	// Alleen de actieve kaart is bruikbaar: de andere tonen hun foto en horen niet in de tabvolgorde.
	const sync = (swiper) => {
		swiper.slides.forEach((slide) => {
			slide.querySelector(".step-card")?.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
		});

		const current = Number(swiper.slides[swiper.activeIndex]?.dataset.step);
		bullets.forEach((bullet, i) => {
			bullet.classList.toggle("swiper-pagination-bullet-active", i === current);
			bullet.toggleAttribute("aria-current", i === current);
		});
	};

	const swiper = new Swiper(slider, {
		modules: [EffectCoverflow, Keyboard],
		effect: "coverflow",
		coverflowEffect: { ...coverflow, stretch: 30 },
		centeredSlides: true,
		slidesPerView: "auto",
		// De tussenruimte (Figma: 8px mobiel, 24px vanaf tablet) staat als padding in de slide, zie style.scss.
		breakpoints: { 768: { coverflowEffect: { ...coverflow, stretch: 0 } } },
		loop: true,
		grabCursor: true,
		// Snapt snel naar de dichtstbijzijnde slide: al na een korte beweging (of vlugge swipe) gaat hij door, en tijdens de loop blijft hij bedienbaar.
		longSwipesRatio: 0.15,
		longSwipesMs: 250,
		threshold: 3,
		loopPreventsSliding: false,
		speed: reduceMotion.matches ? 0 : 450,
		keyboard: { enabled: true, onlyInViewport: true },
		on: {
			init: sync,
			slideChange: sync,
			transitionEnd: sync,
		},
	});

	// Naar de dichtstbijzijnde slide van de gekozen stap.
	const slideToStep = (step) => {
		const nearest = swiper.slides
			.filter((slide) => Number(slide.dataset.step) === step)
			.sort((a, b) => Math.abs(swiper.slides.indexOf(a) - swiper.activeIndex) - Math.abs(swiper.slides.indexOf(b) - swiper.activeIndex))[0];
		if (nearest) swiper.slideToLoop(Number(nearest.dataset.swiperSlideIndex));
	};

	bullets.forEach((bullet, i) => bullet.addEventListener("click", () => slideToStep(i)));

	// Een klik op de foto naast de kaart haalt die slide naar voren. De eigen optie van Swiper (`slideToClickedSlide`) deed hier niets.
	slider.addEventListener("click", (event) => {
		const slide = event.target.closest(".swiper-slide");
		if (!slide || slide.classList.contains("swiper-slide-active")) return;
		swiper.slideToLoop(Number(slide.dataset.swiperSlideIndex));
	});
});
